<!-- eslint-disable -->
<template>
  <CommonPages id="terms" :class="['terms-page']" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">
    <LegalContentLayout title="Terms of Service">
      <div class="legal-richtext">
        <div v-html="termsBody"></div>
      </div>
    </LegalContentLayout>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import LegalContentLayout from '@/components/legal/LegalContentLayout.vue'
import { getContentTextMap, getText, renderTemplate } from '@/utils/contentText';
import { stripLeadingRichTextTitle } from '@/utils/richTextTitle';

import '@/css/common.scss';

const TERMS_BODY = 'Terms of Service<br><br>Welcome to {{SITE_NAME}}. By accessing or using this website, you agree to comply with and be bound by the following terms and conditions.<br><br>1. Acceptance of Terms<br>This website provides a curated ranking of 50 global cities based on specific quality-of-life indicators. By viewing this data, you acknowledge that you have read and understood these Terms of Service. If you do not agree, please discontinue use of the site.<br><br>2. Scope of Service<br>The service consists of a static information display featuring:<br><br>- A curated list of 50 selected global cities.<br><br>- Ratings across five key performance indicators (KPIs).<br><br>- An overall cumulative score for each city.<br><br>- Qualitative summaries and evaluations for each metric.<br><br>3. Data Integrity & Disclaimer<br>The information presented is for general informational and educational purposes only.<br><br>- Subjective Evaluation: The ratings and scores reflect our proprietary methodology and editorial judgment. They are not absolute facts or universal truths.<br><br>- No Professional Advice: This data should not be used as the sole basis for relocation, investment, or legal decisions.<br><br>- As-Is Basis: While we strive for accuracy, the information is provided \"as is\" without warranty of any kind. We are not liable for any inaccuracies or omissions in the city profiles.<br><br>4. Intellectual Property<br>All analytical content, including the scoring framework, the specific selection of the 50 cities, and the written evaluations, is the intellectual property of this website.<br><br>- You may use the information for personal, non-commercial purposes.<br><br>- Redistribution, republication, or commercial exploitation of the rankings without prior written consent is prohibited.<br><br>5. Limitation of Liability<br>In no event shall the operators of this website be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this site.<br><br>6. Third-Party Links<br>Our city evaluations may occasionally mention or link to external resources. We do not endorse or assume responsibility for the content or practices of any third-party websites.<br><br>7. Governing Law<br>Any claim relating to this website shall be governed by the laws of the jurisdiction in which the website operator is based, without regard to its conflict of law provisions.';

export default {
  name: 'Terms',
  components: {
    CommonPages,
    LegalContentLayout
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      'domainConfig',
    ]),
    contentText () {
      return getContentTextMap(this.domainConfig);
    },
    termsBody () {
      const template = getText(this.contentText, 'TERMS_BODY', TERMS_BODY);
      const rendered = renderTemplate(template, {
        SITE_NAME: this.domainConfig?.siteName || 'SITE_NAME',
        CONTACT_EMAIL: this.domainConfig?.IAMEMAIL || this.contentText.CONTACT_EMAIL || 'CONTACT_EMAIL'
      });
      return stripLeadingRichTextTitle(rendered, 'Terms of Service');
    },
    pageMetaTitle () {
      return getText(this.contentText, 'TERMS_META_TITLE', 'Terms of Service');
    },
    pageMetaDescription () {
      return getText(this.contentText, 'HOME_META_DESCRIPTION', 'Terms of Service and conditions of use');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.legal-richtext {
	display: flex;
	flex-direction: column;
	gap: rem(8);
}
</style>
